import React from 'react';
import { Layout } from '../components/Layout';
import { PrivateRoute } from '../components/PrivateRoute';
import { Footer } from '../modules/Footer';
import { Menu } from '../modules/Menu';
import { Transactions } from '../modules/Transactions';
import { TransactionsType as Type } from '../modules/Transactions/utils/types';

const MySales = ({ location }: any) => (
  <div className="bg-wild-sand">
    <Layout>
      <Menu menuHasTwoColors={false} />
      <Transactions type={Type.SALES} locale={location.href} />
      <Footer />
    </Layout>
  </div>
);

const mySalesPage = ({ ...props }) => (
  <PrivateRoute
    location={props.location.pathname}
    locale={props.location.href}
    component={MySales}
  />
);

export default mySalesPage;
